import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { Button } from '../../../Common/Button'
import { Card } from '../../../Common/Card'
import { Flex } from '../../../Common/Flex'
import { Col } from '../../../Common/Grid'
import { H1, Paragraph } from '../../../Common/Typography'
import { setSubscriptionPlan } from '../../store/action'
import { LargePrice } from '../Price/PackagePrice/LargePrice'

import { IProps } from './IProps'
import { PackageList } from './PackageList/PackageList'

export const Package = ({ plan }: IProps) => {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()

  const { price, isBestPick, features, title } = plan

  const planSelect = () => {
    dispatch(setSubscriptionPlan(plan))
    history.push('subscription/details')
  }

  return (
    <Col width={{ sm: 0.5, med: 0.5, lg: 0.25 }}>
      <Card
        mt={!isBestPick && 79}
        overflow={'hidden'}
        padding={2}
        border
        flexDirection={'column'}>
        {isBestPick && (
          <H1
            margin={-2}
            mb={2}
            padding={2}
            color={'lights.3'}
            textAlign={'center'}
            pl={0}
            bg={'primary'}>
            {t('Best pick')}
          </H1>
        )}
        <H1 textAlign={'center'} paddingLeft={0}>
          {t(title)}
        </H1>
        <LargePrice packagePrice={`€${price.nl}/`} packageDuration={'m'} />
        <Flex justifyContent={'center'} flexDirection={'row'}>
          <Button marginBottom={30} onClick={planSelect} bg={'primary'}>
            {t('Subscribe now')}
          </Button>
        </Flex>
        <PackageList features={features} />
      </Card>

      {isBestPick && (
        <Paragraph px={2} mt={1} textAlign={'center'} color={'black'}>
          {t('Would you like a sales expert in your salon?')} &nbsp;
          <a href={'mailto:help@optios.net'}>{t('Contact support')}</a>
        </Paragraph>
      )}
    </Col>
  )
}
